import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { HeaderPlain } from 'components/layout'
import { meta } from 'helpers/decorators'
import config from 'config'

@meta({
  title: 'Page not found',
  intlKey: 'meta.page_not_found'
})
class NotFound extends Component {
  render() {
    return (
      <div>
        <HeaderPlain showLocale={false} />
        <div className="container" style={{ paddingTop: 180 }}>
          <span
            className="ico ico--sad"
            style={{ color: '#A7A9AC', fontSize: 52 }}
          />
          <h1>
            <FormattedMessage
              id="moduleTitle.page_not_found"
              defaultMessage="Sorry, the page you are looking for does not exist."
            />
          </h1>
          <Link to={`${config.publicPath}/`} className="btn">
            <FormattedMessage
              id="button.back_to_home"
              defaultMessage="Back to Home"
            />
          </Link>
        </div>
      </div>
    )
  }
}

export default NotFound
